import { authHeader, handleResponse } from '../utils'
import { API_BASE } from '../config/constants'

const getArtworks = async (type, filterkey='', order=false, pagesize=10, pagefrom=0) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            type,
            filterkey,
            order,
            pagesize,
            pagefrom
        })
    };

    const response = fetch(`${API_BASE}/artwork`, requestOptions)
    return await handleResponse(response);
}

const getArtworkCnt = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };

    const response = fetch(`${API_BASE}/artwork/artworkCnt`, requestOptions)
    return await handleResponse(response);
}

const getArtwork = async (artworkId) => {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    }
    const response = fetch(`${API_BASE}/artwork/${artworkId}`, requestOptions)
    return await handleResponse(response);
};

export const artService = {
    getArtworks,
    getArtworkCnt,
    getArtwork,

}